var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('h1',[_vm._v("Dashboard")])]),_c('v-row',[_c('div',{attrs:{"id":"containerDashboard"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }